'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _required = require('@marmalade/validation/lib/required');
var _required2 = _interopRequireDefault(_required);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _atLeast = require('@marmalade/validation/lib/at-least');
var _atLeast2 = _interopRequireDefault(_atLeast);
var _atMost = require('@marmalade/validation/lib/at-most');
var _atMost2 = _interopRequireDefault(_atMost);
var _postcode = require('@marmalade/validation/lib/postcode');
var _postcode2 = _interopRequireDefault(_postcode);
var _licenceHeld = require('@marmalade/validation/lib/licence-held');
var _licenceHeld2 = _interopRequireDefault(_licenceHeld);
var _licenceHeld3 = require('@marmalade/form/lib/questions/licence-held');
var _vehicleLookup = require('@marmalade/validation/lib/bundles/vehicle-lookup');
var _vehicleLookup2 = _interopRequireDefault(_vehicleLookup);
var _typeOfLicence = require('@marmalade/validation/lib/type-of-licence');
var _typeOfLicence2 = _interopRequireDefault(_typeOfLicence);
var _validateIf = require('@marmalade/validation/lib/validate-if');
var _validateIf2 = _interopRequireDefault(_validateIf);
var _constants = require('../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var licenceHeldValidator = (0, _licenceHeld2.default)(_licenceHeld3.licenceHeldOptions).licenceHeld;
exports.default = Object.assign({
  postcode: _postcode2.default,
  age: (0, _oneByOne2.default)((0, _required2.default)('Please select your age'), (0, _atLeast2.default)(_constants.age.min, 'You must be at least ' + _constants.age.min + ' to take out our named young driver insurance policy'), (0, _atMost2.default)(_constants.age.max, 'You must be under ' + _constants.age.max + ' to take out our named young driver insurance policy')),
  licenceHeld: (0, _validateIf2.default)(function (_, values) {
    return values.licenceType === 'F';
  }, licenceHeldValidator)
}, (0, _vehicleLookup2.default)(_constants.vehicleValue.min, _constants.vehicleValue.max), (0, _typeOfLicence2.default)());